import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// /*eslint-disable import/first*/

import React, { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { IntercomProvider } from 'react-use-intercom';

import { App } from './App';
import * as serviceWorker from './serviceWorker';

import { page, load } from './tracking/segment';

import { initGlobals } from 'utils/init-globals';
import { suppressReactDatesWarnings } from 'utils/suppress-react-dates-warnings';
import { client, history } from 'data/connection/client.connection';
import { CustomThemeProvider } from 'deprecated-enkel';
import { globalStyles } from 'styles';
import { colors, variables } from 'styles/theme';
import type { TotemEnv } from './types/totem-env';

/**
 * Init global variables (including the global TOTEM), and all
 * libraries into it. This is vital for all of them to be accessible across the
 * application.
 */
initGlobals();
suppressReactDatesWarnings();

let prevPath: string | null = null;

// listen and notify Segment of client-side page updates
load();
history.listen((update) => {
    // 'update' is of type Update from 'history', which has a 'location' property
    const pathname = (update as any).location?.pathname ?? '';
    if (pathname !== prevPath) {
        prevPath = pathname;
        page();
    }
});

interface E2EExcludedProvidersProps {
    children: ReactNode;
}

function E2EExcludedProviders({ children }: E2EExcludedProvidersProps) {
    const env = window.__TOTENV__ as TotemEnv;
    if (!env.E2E) {
        return <IntercomProvider appId={env.INTERCOM_APP_ID ?? ''}>{children}</IntercomProvider>;
    }
    return <>{children}</>;
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
const root = createRoot(rootElement);

root.render(
    <E2EExcludedProviders>
        {/* BrowserRouter does not accept history prop in v6+ */}
        <BrowserRouter>
            <ApolloProvider client={client}>
                <CustomThemeProvider colors={colors} variables={variables} globalStyles={globalStyles}>
                    <App />
                </CustomThemeProvider>
            </ApolloProvider>
        </BrowserRouter>
    </E2EExcludedProviders>,
);

/**
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
